import { Box, Pagination, styled, Typography } from '@mui/material';
import Spacing from 'components/Spacing';
import IndividualFeeAccordion, {
  GroupedFeesWithDefaultTransactions,
} from './IndividualFeeAccordion';
import { ListLpFeesCategory } from 'further-types/lp/lp-fee';
import { ApprovalSummaryData } from '..';

interface FeesAccordionProps {
  fees: GroupedFeesWithDefaultTransactions;
  currentPage: number;
  onPageChange: (page: number) => void;
  feeType: ListLpFeesCategory;
  setApprovalSummaryData?: (data: ApprovalSummaryData) => void;
}

const StyledPagination = styled(Pagination)({
  display: 'flex',
  justifyContent: 'center',
  mt: 2,
});

const StyledNotFoundBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  mt: 2,
  border: '1px solid #E0E0E0',
  borderRadius: '4px',
  padding: '16px',
});

const notFoundMessages = {
  [ListLpFeesCategory.FutureUnapprovedFees]: 'No future unapproved fees found.',
  [ListLpFeesCategory.DueUnapprovedFees]:
    'No unapproved fees found that are due for processing.',
  [ListLpFeesCategory.ApprovedFees]: 'No approved fees found.',
};

const FeesAccordion: React.FC<FeesAccordionProps> = ({
  fees,
  currentPage,
  onPageChange,
  feeType,
  setApprovalSummaryData,
}) => {
  const { totalPages, groupedFees, defaultTransactions } = fees;
  const notFoundMessage = notFoundMessages[feeType];

  if (totalPages === 0) {
    return (
      <StyledNotFoundBox>
        <Spacing size="sm">
          <Typography>{notFoundMessage}</Typography>
        </Spacing>
      </StyledNotFoundBox>
    );
  }

  return (
    <>
      {groupedFees.map((feeGroup, index) => (
        <IndividualFeeAccordion
          key={`${feeGroup.accrualDate.toString()}-${index}`}
          date={feeGroup.accrualDate}
          feeList={feeGroup.lpFees}
          feeType={feeType}
          expandFirst={
            index === 0 && feeType === ListLpFeesCategory.DueUnapprovedFees
          }
          defaultTransactions={defaultTransactions}
          setApprovalSummaryData={setApprovalSummaryData}
        />
      ))}
      {totalPages > 1 && (
        <Spacing size="sm">
          <StyledPagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
          />
        </Spacing>
      )}
    </>
  );
};

export default FeesAccordion;
